// Delivery fee calculator. Mirrors compute_delivery_fee() in backend/server.py
// so customers see the right total in the Cart and Checkout summary BEFORE
// submitting. Backend re-computes authoritatively at /api/orders/checkout.
//
// Rules (set by user 2026-04-29):
//   Non-Sunjin (Groceries / Meats / Frozen Products / Condiments):
//     - subtotal < ₱1,000 → ₱20 delivery
//     - subtotal ≥ ₱1,000 → free
//   Sunjin Feeds:
//     - 1+ full sacks bought → ₱10 × number of sacks
//     - only half-sack / per-kilo / pack → ₱20 flat
//     - no Sunjin items → no charge
//   Mixed cart: the two charges are added together.

export const FREE_DELIVERY_THRESHOLD = 1000;        // ₱ for non-Sunjin free delivery
export const NON_SUNJIN_DELIVERY = 20;              // ₱ when below threshold
export const SUNJIN_PER_SACK = 10;                  // ₱ per full sack
export const SUNJIN_FRACTIONAL_FLAT = 20;           // ₱ when only fractional Sunjin items

const isSunjin = (item) => item.category === "Sunjin Feeds" || item.variant_id != null;

export function computeDeliveryBreakdown(items) {
  const sunjin = items.filter(isSunjin);
  const other = items.filter((i) => !isSunjin(i));

  let nonSunjinFee = 0;
  const otherSubtotal = other.reduce((s, i) => s + i.price * i.quantity, 0);
  if (other.length && otherSubtotal < FREE_DELIVERY_THRESHOLD) {
    nonSunjinFee = NON_SUNJIN_DELIVERY;
  }

  let sunjinFee = 0;
  let sackQty = 0;
  let hasNonSack = false;
  if (sunjin.length) {
    sackQty = sunjin.filter((i) => i.variant_id === "sack").reduce((s, i) => s + i.quantity, 0);
    hasNonSack = sunjin.some((i) => ["half", "kilo", "pack"].includes(i.variant_id));
    if (sackQty > 0) {
      sunjinFee = SUNJIN_PER_SACK * sackQty;
    } else if (hasNonSack) {
      sunjinFee = SUNJIN_FRACTIONAL_FLAT;
    }
  }

  return {
    nonSunjinSubtotal: otherSubtotal,
    nonSunjinFee,
    sunjinSackQty: sackQty,
    sunjinHasNonSack: hasNonSack,
    sunjinFee,
    totalFee: nonSunjinFee + sunjinFee,
  };
}

export function computeDeliveryFee(items) {
  return computeDeliveryBreakdown(items).totalFee;
}
